import { TFunction } from 'i18next';

const localeGroups = {
  en: [
    'en',
    'en-US',
    'en-GB',
    'en-CA',
    'en-AU',
    'en-NZ',
    'en-IE',
    'en-ZA',
    'en-IN',
  ],
  'es-419': [
    'es',
    'es-419',
    'es-ES',
    'es-MX',
    'es-AR',
    'es-CO',
    'es-CL',
    'es-PE',
    'es-VE',
    'es-UY',
    'es-PY',
    'es-BO',
    'es-EC',
    'es-GT',
    'es-HN',
    'es-SV',
    'es-NI',
    'es-CR',
    'es-PA',
    'es-CU',
    'es-DO',
    'es-PR',
  ],
  'pt-BR': [
    'pt',
    'pt-BR',
    'pt-PT',
    'pt-AO',
    'pt-MZ',
    'pt-GW',
    'pt-ST',
    'pt-CV',
    'pt-TL',
  ],
  fr: ['fr', 'fr-FR', 'fr-CA', 'fr-BE', 'fr-CH', 'fr-LU', 'fr-MC'],
  de: ['de', 'de-DE', 'de-AT', 'de-CH', 'de-BE', 'de-LI', 'de-LU'],
  tr: ['tr', 'tr-TR', 'tr-CY'],
  it: ['it', 'it-IT', 'it-CH', 'it-SM', 'it-VA'],
} as const;

const canonicalLocales: Record<string, string[]> = Object.entries(
  localeGroups,
).reduce(
  (acc, [canonical, variants]) => {
    variants.forEach((v) => {
      acc[v] = [canonical];
    });
    return acc;
  },
  {} as Record<string, string[]>,
);

const getCanonicalLocale = (lng?: string): string => {
  if (!lng) {
    return 'en';
  }

  return (
    canonicalLocales[lng][0] || canonicalLocales[lng.split('-')[0]][0] || 'en'
  );
};

const getLanguages = (): {
  getText: (t: TFunction) => string;
  value: string;
}[] => {
  return [
    {
      getText: (t: TFunction): string => t(`languages:english`, 'English'),
      value: 'en',
    },
    {
      getText: (t: TFunction): string => t(`languages:spanish`, 'Spanish'),
      value: 'es-419',
    },
    {
      getText: (t: TFunction): string =>
        t(`languages:portuguese`, 'Portuguese'),
      value: 'pt-BR',
    },
    {
      getText: (t: TFunction): string => t(`languages:french`, 'French'),
      value: 'fr',
    },
    {
      getText: (t: TFunction): string => t(`languages:german`, 'German'),
      value: 'de',
    },
    {
      getText: (t: TFunction): string => t(`languages:turkish`, 'Turkish'),
      value: 'tr',
    },
    {
      getText: (t: TFunction): string => t(`languages:italian`, 'Italian'),
      value: 'it',
    },
  ];
};

export { canonicalLocales, getCanonicalLocale, getLanguages };
